/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

export const getPeriodOptions = (asPeriodicity = true) => [
  {
    value: DataPeriods.Monthly,
    label: getPeriodName(DataPeriods.Monthly, asPeriodicity),
  },
  {
    value: DataPeriods.Quarterly,
    label: getPeriodName(DataPeriods.Quarterly, asPeriodicity),
  },
  {
    value: DataPeriods.Yearly,
    label: getPeriodName(DataPeriods.Yearly, asPeriodicity),
  },
];

export function getPeriodName(period: DataPeriods | undefined, asPeriodicity = true) {
  switch (period) {
    case DataPeriods.Monthly:
      return asPeriodicity ? 'Monthly' : 'Month';
    case DataPeriods.Quarterly:
      return asPeriodicity ? 'Quarterly' : 'Quarter';
    case DataPeriods.Yearly:
    default:
      return asPeriodicity ? 'Annually' : 'Annual';
  }
}

export enum DataPeriods {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}
